








































import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import authApi from '@/common/auth'
import util from '@/common/util'

const Aftersales = namespace('aftersales')

@Component({})
export default class CarContacts extends Vue {
  @Prop(Array) readonly contacts!: any[];
  @Aftersales.State('userInfo') userInfo: any;

  isOpen = false
  handleToggleOpen() {
    this.isOpen = !this.isOpen
  }

  canChangeContacts = false;

  mounted() {
    this.getChangeContactsAuth()
  }

  async getChangeContactsAuth() {
    const { authList } = await this.$store.state.promiseAuth
    this.canChangeContacts = authApi.haveSomeAuth([authApi.aftersales.customer_contacts_add], authList)
  }

  get hasMobileType() {
    const deviceType = util.getDeviceType()
    const dict = {
      'Mac OS': 1,
      'Windows': 1,
      'Android': 2,
      'IOS': 2,
      'unknown': 0
    }
    return dict[deviceType] === 2
  }
  hasCallMobile(mobileNumber: string) {
    return this.hasMobileType && util.regexpMap.regexp_mobile.test(mobileNumber)
  }
}
